import * as angular from "angular";

export class InternalController {
  public static $inject: any[] = [];

  constructor() {}
}

angular
  .module("PortalApp")
  .controller("Rhinestone.InternalController", InternalController);
